module.exports = __webpack_public_path__ + "img/kigebu-logo.c38373af.png";